import { useMemo, useState } from 'react';
import { TableContext } from './TableContext';
import { useSelected } from './useSelected';
export function TableContextProvider(props) {
    const { results = [], actions, children } = props;
    const [selected, setSelected] = useSelected(results);
    const [activeAction, setActiveAction] = useState();
    const hasBulkActions = Boolean(actions);
    const contextValue = useMemo(() => ({ activeAction, setActiveAction, selected, setSelected, results, actions: hasBulkActions }), [activeAction, selected, setSelected, results, hasBulkActions]);
    return (<TableContext.Provider value={contextValue}>
      {children}
      {actions}
    </TableContext.Provider>);
}
